
export default class LayoutLightboxVideo {
  private el: {
    body: HTMLElement,
    btClose: HTMLElement,
    buttons: NodeListOf<HTMLElement>,
    itemContainer: HTMLElement,
  };

  private className = {
    active: 'lightbox-video-is-open',
  };

  private isOpen = false;

  private cache() {
    this.el = {
      body: document.body,
      btClose: document.querySelector('#js-l-lv__bt-close') as HTMLElement,
      itemContainer: document.querySelector('#js-l-lv__item') as HTMLElement,
      buttons: document.querySelectorAll('[data-lightboxvideo]'),
    }
  }

  private bindings() {
    const { el } = this;
    el.buttons.forEach(
      (elButton) => {
        elButton.addEventListener(
          'click', () => this.open(String(elButton.dataset.lightboxvideo))
        );
      }
    );

    el.btClose?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') this.close();
    });
  }

  private open(video: string) {
    const { el, className} = this;

    let html = '';
    const urlVideo = video;
    html += `<video controls playsinline src="${urlVideo}"></video>`;

    el.itemContainer.innerHTML = `${html}`;
    const vid = el.itemContainer.querySelector('video') as HTMLVideoElement;

    // Must call play() synchronously in the click handler for iOS Safari
    const playPromise = vid.play();

    if (playPromise !== undefined) {
      playPromise.then(() => {
        // iOS Safari: webkitEnterFullscreen
        if ('webkitEnterFullscreen' in vid) {
          (vid as any).webkitEnterFullscreen();
        } else if (vid.requestFullscreen) {
          vid.requestFullscreen();
        }
      }).catch((error) => {
        console.warn('Fullscreen playback failed:', error);
      });
    }

    /* this.swiperCarousel = new Swiper(el.itemsContainer, {
      preloadImages: false,
      grabCursor: true,
      loop: true,
      lazy: {
        loadPrevNext: true,
      },
    }); */
    /* this.swiperCarousel.lazy.load(); */

    el.body.classList.add(className.active);
    this.isOpen = true;
  }

  private close() {
    const { el, className} = this;

    if (this.isOpen === true) {
      el.body.classList.remove(className.active);
      this.isOpen = false;
      el.itemContainer.querySelector('video')?.pause();
      /* if (this.swiperCarousel) {
        this.swiperCarousel.destroy();
        this.swiperCarousel = null;
      } */
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}
